<template>
    <!-- 活动-优惠券类型-编辑对话框 -->
    <el-drawer :visible.sync="show" :with-header="false" :before-close="closeDialog" size="600px">
        <!-- 基本信息表单 -->
        <div class="form-box" v-if="inspection_status == '0'">
            <el-form ref="form" :model="submit_data" label-width="80px" style="overflow-y: auto; height: 85vh">
                <el-form-item label-width="50px">
                    <el-switch v-model="submit_data.status" active-text="启用" inactive-text="禁用" active-value="1" inactive-value="0">
                    </el-switch>
                </el-form-item>

                <el-form-item label-width="50px">
                    <el-switch
                        v-model="submit_data.only_month_card"
                        active-text="仅限月卡"
                        inactive-text=""
                        active-value="1"
                        inactive-value="0"
                    >
                    </el-switch>
                </el-form-item>

                <el-form-item label-width="50px">
                    <el-switch v-model="submit_data.only_vip" active-text="仅限vip" inactive-text="" active-value="1" inactive-value="0">
                    </el-switch>
                </el-form-item>

                <el-form-item label-width="50px">
                    <el-switch v-model="submit_data.is_show" active-text="是否显示" inactive-text="" active-value="1" inactive-value="0">
                    </el-switch>
                </el-form-item>

                <el-form-item label-width="50px">
                    <el-switch
                        v-model="submit_data.only_online_pay"
                        active-text="仅线上支付可用"
                        inactive-text=""
                        active-value="1"
                        inactive-value="0"
                    >
                    </el-switch>
                </el-form-item>

                <el-form-item label-width="50px">
                    <el-switch v-model="submit_data.is_scan" active-text="扫码发券" inactive-text="" active-value="1" inactive-value="0">
                    </el-switch>
                </el-form-item>

                <el-form-item label-width="50px">
                    <el-switch v-model="submit_data.is_douyin" active-text="抖音专属" inactive-text="" active-value="1" inactive-value="0">
                    </el-switch>
                </el-form-item>

                <el-form-item label-width="50px">
                    <el-switch
                        v-model="submit_data.is_padan"
                        active-text="创单模式不可用"
                        inactive-text=""
                        active-value="1"
                        inactive-value="0"
                    >
                    </el-switch>
                </el-form-item>

                <el-form-item label="领取范围:" label-width="120px">
                    <el-select v-model="submit_data.is_new_visit" placeholder="请选择" style="width: 150px; margin-right: 20px" clearable>
                        <el-option label="全部" value="0"> </el-option>
                        <el-option label="新用户" value="1"> </el-option>
                        <el-option label="老用户" value="2"> </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="三方标识:" label-width="120px">
                    <el-select
                        v-model="submit_data.other_activity_tag"
                        placeholder="请选择城市"
                        style="width: 150px; margin-right: 20px"
                        clearable
                    >
                        <el-option v-for="item in other_select" :label="item.name" :value="item.key"> </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="优惠券名称:" label-width="120px">
                    <el-input v-model="submit_data.name" :placeholder="submit_rules.name.placeholder" style="width: 80%"> </el-input>
                </el-form-item>

                <el-form-item label="优惠券备注:" label-width="120px">
                    <el-input v-model="submit_data.description" :placeholder="submit_rules.description.placeholder" style="width: 80%">
                    </el-input>
                </el-form-item>

                <el-form-item label="满减条件:" label-width="120px">
                    <el-input
                        v-model="submit_data.full_price"
                        :placeholder="submit_rules.full_price.placeholder"
                        style="width: 80%"
                    ></el-input>
                    元
                </el-form-item>

                <el-form-item label="满减金额:" label-width="120px">
                    <el-input
                        v-model="submit_data.sub_price"
                        :placeholder="submit_rules.sub_price.placeholder"
                        style="width: 80%"
                    ></el-input>
                    元
                </el-form-item>
                <el-form-item label="司机承担金额:" label-width="120px">
                    <el-input
                        v-model="submit_data.bear_price"
                        :placeholder="submit_rules.bear_price.placeholder"
                        style="width: 80%"
                    ></el-input>
                    元
                </el-form-item>

                <el-form-item label="标签:" label-width="120px">
                    <el-input clearable v-model="submit_data.coupon_tag" style="width: 50%"></el-input>
                    <el-popover placement="top-start" trigger="hover" content="相同标签的优惠券不可重复领取">
                        <el-button @click="getCouponTag" style="margin-left: 10px" slot="reference">获取标签</el-button>
                    </el-popover>
                </el-form-item>

                <el-form-item label="可用日期:" label-width="120px">
                    <el-switch v-model="date_switch"> </el-switch>

                    <template v-if="date_switch">
                        <el-checkbox-group v-model="date_month" size="mini" style="border-bottom: 1px dashed #ccc; margin-bottom: 10px">
                            <el-checkbox :label="item" border style="margin: 5px" v-for="(item, index) in month_lists">
                                {{ item }}月
                            </el-checkbox>
                        </el-checkbox-group>

                        <el-checkbox-group v-model="date_date" size="mini" style="border-bottom: 1px dashed #ccc; margin-bottom: 10px">
                            <el-checkbox :label="item" border style="margin: 5px" v-for="(item, index) in date_lists">
                                {{ item }}日
                            </el-checkbox>
                        </el-checkbox-group>

                        <el-checkbox-group v-model="date_week" size="mini">
                            <el-checkbox :label="item" border style="margin: 5px" v-for="(item, index) in week_lists">
                                星期{{ week_lists_chinese[index] }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </template>
                </el-form-item>

                <el-form-item label="可用时间段:" label-width="120px">
                    <el-switch v-model="time_switch"> </el-switch>

                    <div v-if="time_switch">
                        <div v-for="(item, index) in time_synchronization" style="border-bottom: 1px dashed #ccc; margin-bottom: 10px">
                            <el-form-item label="开始时间" label-width="120px">
                                <el-time-picker
                                    v-model="time_synchronization[index].start_time"
                                    :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }"
                                    placeholder="开始时间"
                                    value-format="HHmm"
                                    format="HH:mm"
                                >
                                </el-time-picker>
                            </el-form-item>

                            <el-form-item label="结束时间" label-width="120px">
                                <el-time-picker
                                    v-model="time_synchronization[index].end_time"
                                    :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }"
                                    placeholder="结束时间"
                                    value-format="HHmm"
                                    format="HH:mm"
                                >
                                </el-time-picker>
                            </el-form-item>
                        </div>
                        <el-button @click="addTimeFun">增加时间段</el-button>
                        <el-button @click="popTime">移除时间段</el-button>
                    </div>
                </el-form-item>

                <el-form-item label="领取限制:" label-width="120px">
                    <el-switch v-model="receive_switch"> </el-switch>

                    <div v-if="receive_switch">
                        <div>
                            每年领取
                            <el-input v-model="receive_year" style="width: 80px"></el-input>
                            张
                        </div>
                        <div>
                            每月领取
                            <el-input v-model="receive_month" style="width: 80px"></el-input>
                            张
                        </div>
                        <div>
                            每周领取
                            <el-input v-model="receive_week" style="width: 80px"></el-input>
                            张
                        </div>
                        <div>
                            每天领取
                            <el-input v-model="receive_day" style="width: 80px"></el-input>
                            张
                        </div>
                    </div>
                </el-form-item>

                <el-form-item label-width="50px">
                    <el-switch v-model="all_order_isTrue" active-text="非全模式可用" inactive-text="全模式可用"> </el-switch>
                </el-form-item>

                <!-- 选择订单模式 -->
                <el-form-item label="订单模式:" label-width="120px" v-if="options_order_code.length != 0 && all_order_isTrue">
                    <el-checkbox-group v-model="order_mode_code_array" size="mini" @change="modeChange">
                        <el-checkbox v-for="(item, index) in options_order_code" :label="item.code" border style="margin: 5px">
                            {{ item.name }}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>

                <el-form-item label="发行数量:" label-width="120px">
                    <el-input
                        v-model="submit_data.grant_quantity"
                        :placeholder="submit_rules.grant_quantity.placeholder"
                        style="width: 80%"
                    >
                    </el-input>
                    张
                </el-form-item>

                <el-form-item label="剩余数量:" label-width="120px">
                    <el-input v-model="submit_data.quantity" :placeholder="submit_rules.quantity.placeholder" style="width: 80%">
                    </el-input>
                    张
                </el-form-item>

                <el-form-item label="发放开始日期:" label-width="120px">
                    <el-date-picker
                        type="date"
                        :placeholder="submit_rules.start_time.placeholder"
                        v-model="submit_data.start_time"
                        value-format="yyyy-MM-dd"
                        style="width: 80%"
                    ></el-date-picker>
                </el-form-item>

                <el-form-item label="发放截止日期:" label-width="120px">
                    <el-date-picker
                        type="date"
                        :placeholder="submit_rules.end_time.placeholder"
                        v-model="submit_data.end_time"
                        value-format="yyyy-MM-dd"
                        style="width: 80%"
                    ></el-date-picker>
                </el-form-item>

                <el-form-item label="延迟使用:" label-width="120px">
                    <el-input v-model="submit_data.can_use_day" :placeholder="submit_rules.can_use_day.placeholder" style="width: 80%">
                    </el-input>
                    天
                </el-form-item>

                <el-form-item label="扫码发放数量:" label-width="120px">
                    <el-input v-model="submit_data.grant_num" :placeholder="submit_rules.grant_num.placeholder" style="width: 80%">
                    </el-input>
                    张
                </el-form-item>

                <el-form-item label="总领取数量:" label-width="120px">
                    <el-input v-model="submit_data.max_count" :placeholder="submit_rules.max_count.placeholder" style="width: 80%">
                    </el-input>
                    张
                </el-form-item>

                <el-form-item label="可持有数量:" label-width="120px">
                    <el-input
                        v-model="submit_data.max_hold_count"
                        :placeholder="submit_rules.max_hold_count.placeholder"
                        style="width: 80%"
                    >
                    </el-input>
                    张
                </el-form-item>

                <el-form-item label="使用时间:" label-width="120px">
                    <el-radio-group v-model="submit_data.use_type">
                        <el-radio label="0">指定日期</el-radio>
                        <el-radio label="1">有效天数</el-radio>
                    </el-radio-group>
                </el-form-item>
                <div v-if="submit_data.use_type == '0'">
                    <el-form-item label="使用开始日期:" label-width="120px">
                        <el-date-picker
                            type="date"
                            :placeholder="submit_rules.use_start_time.placeholder"
                            v-model="submit_data.use_start_time"
                            value-format="yyyy-MM-dd"
                            style="width: 80%"
                        ></el-date-picker>
                    </el-form-item>

                    <el-form-item label="使用截止日期:" label-width="120px">
                        <el-date-picker
                            type="date"
                            :placeholder="submit_rules.use_end_time.placeholder"
                            v-model="submit_data.use_end_time"
                            value-format="yyyy-MM-dd"
                            style="width: 80%"
                        ></el-date-picker>
                    </el-form-item>
                </div>
                <el-form-item label="自领券当日起:" label-width="120px" v-if="submit_data.use_type == '1'">
                    <el-input v-model="submit_data.use_days" :placeholder="submit_rules.use_days.placeholder" style="width: 80%">
                    </el-input>
                    天内可用
                </el-form-item>
            </el-form>

            <!-- 对话框底部按钮 -->
            <div style="display: flex; justify-content: center">
            
                <submitBtn
                    @onSubmitDig="onSubmitDig"
                    @toJSON="toJSON"
                    :data="submit_data"
                    :rules="submit_rules"
                    :url="submit_url"
                    :JSON_Boolean="true"
                ></submitBtn>
                <el-button @click="closeDialog">关闭</el-button>
            </div>
        </div>

        <div class="form-box" v-else>
            <el-form ref="form" :model="submit_data" label-width="80px" style="overflow-y: auto; height: 85vh; padding-top: 20px">
                <el-form-item label-width="50px">
                    <el-switch v-model="inspection_data.status" active-text="启用" inactive-text="禁用" active-value="1" inactive-value="0">
                    </el-switch>
                </el-form-item>

                <el-form-item label-width="50px">
                    <el-switch
                        v-model="inspection_data.is_show"
                        active-text="是否显示"
                        inactive-text=""
                        active-value="1"
                        inactive-value="0"
                    >
                    </el-switch>
                </el-form-item>

                <el-form-item label-width="50px">
                    <el-switch
                        v-model="inspection_data.only_online_pay"
                        active-text="仅限线上支付"
                        inactive-text=""
                        active-value="1"
                        inactive-value="0"
                    >
                    </el-switch>
                </el-form-item>

                <el-form-item label="优惠券名称:" label-width="120px">
                    <el-input v-model="inspection_data.name" style="width: 80%"> </el-input>
                </el-form-item>

                <el-form-item label="描述:" label-width="120px">
                    <el-input v-model="inspection_data.description" style="width: 80%"> </el-input>
                </el-form-item>

                <el-form-item label="满足金额:" label-width="120px">
                    <el-input v-model="inspection_data.full_price" style="width: 80%"> </el-input>
                </el-form-item>

                <el-form-item label="优惠金额:" label-width="120px">
                    <el-input v-model="inspection_data.sub_price" style="width: 80%"> </el-input>
                </el-form-item>

         

                <el-form-item label="发行数量:" label-width="120px">
                    <el-input v-model="inspection_data.grant_quantity" style="width: 80%"> </el-input>
                </el-form-item>

                <el-form-item label="可领取总数量:" label-width="120px">
                    <el-input v-model="inspection_data.max_count" style="width: 80%"> </el-input>
                </el-form-item>

                <el-form-item label="使用开始日期:" label-width="120px">
                    <el-date-picker
                        type="date"
                        v-model="inspection_data.use_start_time"
                        value-format="yyyy-MM-dd"
                        style="width: 80%"
                    ></el-date-picker>
                </el-form-item>

                <el-form-item label="使用截止日期:" label-width="120px">
                    <el-date-picker
                        type="date"
                        v-model="inspection_data.use_end_time"
                        value-format="yyyy-MM-dd"
                        style="width: 80%"
                    ></el-date-picker>
                </el-form-item>

                <div style="display: flex; justify-content: center">
                  
                    <submitBtn @onSubmitDig="onSubmitDig" :data="inspection_data" url="/coupon/editInspectionCouponModeSubmit"></submitBtn>
                    <el-button @click="closeDialog">关闭</el-button>
                </div>
            </el-form>
        </div>
    </el-drawer>
</template>

<script>
var _this;
export default {
    props: {
        isShow: Boolean,
        data: '',
        inspection_status: ''
    },
    components: {},
    watch: {
        isShow(newData, oldData) {
            _this.show = true;

            _this.submit_data.coupon_mode_code = _this.data;
            _this.inspection_data.coupon_mode_code = _this.data;

            // 获取订单模式
            _this.orderModeList();

           
            // 获取三方标识
            _this
                .$post('/cooperator/getCooperatorList')
                .then((res) => {
                    _this.other_select = res.data;
                })
                .catch((err) => {});

            // 获取优惠券详情
            _this
                .$post('/coupon/getCouponModeDetails', {
                    coupon_mode_code: _this.data
                })
                .then((res) => {
                    if (_this.inspection_status == '0') {
                        //    代驾优惠券

                        _this.submit_data.name = res.data.name;
                        _this.submit_data.description = res.data.description;
                        _this.submit_data.full_price = res.data.full_price;
                        _this.submit_data.sub_price = res.data.sub_price;
                        _this.submit_data.bear_price = res.data.bear_price;
                        _this.submit_data.grant_quantity = res.data.grant_quantity;
                        _this.submit_data.quantity = res.data.quantity;
                        _this.submit_data.can_use_day = res.data.can_use_day;
                        _this.submit_data.max_count = res.data.max_count;
                        _this.submit_data.max_hold_count = res.data.max_hold_count;
                        _this.submit_data.only_month_card = res.data.only_month_card.val;
                        _this.submit_data.only_vip = res.data.only_vip.val;
                        _this.submit_data.only_online_pay = res.data.only_online_pay.val;
                        _this.submit_data.other_activity_tag = res.data.other_activity_tag;
                        _this.submit_data.is_show = res.data.is_show.val;
                        _this.submit_data.start_time = res.data.start_time.Ymd;
                        _this.submit_data.end_time = res.data.end_time.Ymd;

                        _this.submit_data.use_days = res.data.use_days;
                        _this.submit_data.use_type = res.data.use_type;
                        console.log(_this.submit_data.use_days, '_this.submit_data.use_type');

                        _this.submit_data.use_start_time = res.data.use_start_time.Ymd == '未设置' ? '' : res.data.use_start_time.Ymd;
                        _this.submit_data.use_end_time = res.data.use_end_time.Ymd == '未设置' ? '' : res.data.use_end_time.Ymd;

                        _this.submit_data.status = res.data.status.val;
                        _this.submit_data.is_scan = res.data.is_scan.val;
                        _this.submit_data.coupon_tag = res.data.coupon_tag;
                        _this.submit_data.grant_num = res.data.grant_num;
                        _this.submit_data.is_douyin = res.data.is_douyin.val;

                        _this.submit_data.is_padan = res.data.is_padan.val;

                        _this.submit_data.is_new_visit = res.data.is_new_visit.val;

                        //可用日期

                        if (
                            res.data.date_synchronization.day.length == 0 &&
                            res.data.date_synchronization.month.length == 0 &&
                            res.data.date_synchronization.week.length == 0
                        ) {
                            _this.date_switch = false;
                        } else {
                            _this.date_switch = true;
                            _this.date_month = res.data.date_synchronization.month;
                            _this.date_week = res.data.date_synchronization.week;
                            _this.date_date = res.data.date_synchronization.day;
                        }

                        // 可用时间段开关
                        if (res.data.time_synchronization.length == 0) {
                            _this.time_switch = false;
                        } else {
                            _this.time_switch = true;
                            _this.time_synchronization = res.data.time_synchronization;
                        }

                        // 领取限制
                        if (
                            res.data.receive_synchronization.day == '' ||
                            res.data.receive_synchronization.month == '' ||
                            res.data.receive_synchronization.week == '' ||
                            res.data.receive_synchronization.year == ''
                        ) {
                            _this.receive_switch = false;
                        } else {
                            _this.receive_switch = true;
                            _this.receive_year = res.data.receive_synchronization.year;
                            _this.receive_month = res.data.receive_synchronization.month;
                            _this.receive_week = res.data.receive_synchronization.week;
                            _this.receive_day = res.data.receive_synchronization.day;
                        }

                        // 判断选中模式数据是否为空
                        if (res.data.order_mode_code_array == null || res.data.order_mode_code_array.length == 0) {
                            _this.all_order_isTrue = false;
                        } else {
                            _this.all_order_isTrue = true;

                            for (let i = 0; i < res.data.order_mode_code_array.length; i++) {
                                _this.order_mode_code_array.push(res.data.order_mode_code_array[i].order_mode_code);
                            }

                            console.log(_this.order_mode_code_array,'00000');
                        }
                            console.log(_this.order_mode_code_array,'00000');

                    } else if (_this.inspection_status == '1') {
                        //    检车优惠券
                        _this.inspection_data.status = res.data.status.val;
                        _this.inspection_data.name = res.data.name;
                        _this.inspection_data.description = res.data.description;
                        _this.inspection_data.full_price = res.data.full_price;
                        _this.inspection_data.sub_price = res.data.sub_price;
                        _this.inspection_data.bear_price = res.data.bear_price;
                        _this.inspection_data.grant_quantity = res.data.grant_quantity;
                        _this.inspection_data.max_count = res.data.max_count;
                        _this.inspection_data.use_start_time = res.data.use_start_time.Ymd;
                        _this.inspection_data.use_end_time = res.data.use_end_time.Ymd;
                        _this.inspection_data.only_online_pay = res.data.only_online_pay.val;
                        _this.inspection_data.is_show = res.data.is_show.val;
                    }
                })
                .catch((err) => {});
        }
    },
    data() {
        return {
            // 订单模式查询条件
            mode_options_data: {
                page: 1,
                limit: 10,
                status: '1'
            },
            show: false,
            month_lists: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
            date_lists: [
                '1',
                '2',
                '3',
                '4',
                '5',
                '6',
                '7',
                '8',
                '9',
                '10',
                '11',
                '12',
                '13',
                '14',
                '15',
                '16',
                '17',
                '18',
                '19',
                '20',
                '21',
                '22',
                '23',
                '24',
                '25',
                '26',
                '27',
                '28',
                '29',
                '30',
                '31'
            ],
            week_lists: ['1', '2', '3', '4', '5', '6', '7'],
            week_lists_chinese: ['一', '二', '三', '四', '五', '六', '日'],
            // 可用日期开关
            date_switch: false,

            other_select: [],
            // 选中可用日期(月份)
            date_month: [],

            // 选中可用日期(星期)
            date_week: [],

            // 选中可用日期(日期)
            date_date: [],

            //可用时间段开关
            time_switch: false,
            time_synchronization: [
                {
                    start_time: '',
                    end_time: ''
                }
            ],

            // 领取限制开关
            receive_switch: false,
            receive_year: '',
            // 选中领取限制(月份)
            receive_month: '',
            // 选中领取限制(星期)
            receive_week: '',
            // 选中领取限制(日期)
            receive_day: '',

            // 全模式可用开关
            all_order_isTrue: false,

            //订单模式数据
            options_order_code: [],

            // 选中订单模式
            order_mode_code_array: [],

            submit_url: '/coupon/editCouponModeSubmit',

            // 表单数据
            submit_data: {
                coupon_mode_code: '',
                name: '',
                description: '',
                full_price: '',
                sub_price: '',
                bear_price: '',
                date_synchronization: '',
                time_synchronization: '',
                receive_synchronization: '',
                order_mode_code_array: '',
                grant_quantity: '',
                quantity: '',
                start_time: '',
                end_time: '',
                can_use_day: '',
                max_count: '',
                max_hold_count: '',
                use_start_time: '',
                use_type: '0',
                use_days: '0',

                use_end_time: '',
                only_month_card: '0',
                only_vip: '0',
                other_activity_tag: '',
                is_show: '0',
                status: '',
                only_online_pay: '',
                is_scan: '0',
                coupon_tag: '',
                clear_coupon_tag: '',
                grant_num: '',
                is_douyin: '0',
                is_padan: '0',
                is_new_visit: '0'
            },

            submit_rules: {
                name: {
                    placeholder: '请输入优惠券名称',
                    rules: {
                        required: true,
                        message: '优惠券名称不能超过6个字',
                        regulation: 'lt_str',
                        rulesData: 7
                    }
                },
                description: {
                    placeholder: '优惠券备注',
                    rules: {
                        required: true,
                        message: '优惠券备注需100字以内',
                        regulation: 'lt_str',
                        rulesData: 100
                    }
                },
                full_price: {
                    placeholder: '请输入满减条件',
                    rules: {
                        required: true,
                        message: '满减条件错误',
                        regulation: 'egt_str',
                        rulesData: 0
                    }
                },
                sub_price: {
                    placeholder: '请输入满减金额',
                    rules: {
                        required: true,
                        message: '满减金额错误',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                bear_price: {
                    placeholder: '请输入司机承担金额',
                    rules: {
                        required: true,
                        message: '满减条件错误',
                        regulation: 'egt_str',
                        rulesData: 0
                    }
                },
                date_synchronization: {
                    placeholder: '可用日期',
                    rules: {
                        required: true,
                        message: '可用日期',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                time_synchronization: {
                    placeholder: '可用时间段',
                    rules: {
                        required: true,
                        message: '可用时间段',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                receive_synchronization: {
                    placeholder: '领取限制',
                    rules: {
                        required: true,
                        message: '领取限制错误',
                        regulation: 'egt_str',
                        rulesData: 0
                    }
                },
                order_mode_code_array: {
                    placeholder: '模式编码',
                    rules: {
                        required: false,
                        message: '模式编码错误',
                        regulation: 'egt_str',
                        rulesData: 0
                    }
                },
                grant_quantity: {
                    placeholder: '请输入发行数量',
                    rules: {
                        required: true,
                        message: '发行数量错误',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },

                quantity: {
                    placeholder: '请输入剩余数量',
                    rules: {
                        required: true,
                        message: '剩余数量错误',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },

                start_time: {
                    placeholder: '请输入开始日期',
                    rules: {
                        required: true,
                        message: '请输入开始时间',
                        regulation: 'lt_str',
                        rulesData: 30
                    }
                },
                end_time: {
                    placeholder: '请输入结束日期',
                    rules: {
                        required: true,
                        message: '请输入结束时间',
                        regulation: 'lt_str',
                        rulesData: 30
                    }
                },
                can_use_day: {
                    placeholder: '请输入延迟使用天数',
                    rules: {
                        required: true,
                        message: '延迟使用天数错误',
                        regulation: 'egt_str',
                        rulesData: 0
                    }
                },
                max_count: {
                    placeholder: '请输入总领取数量',
                    rules: {
                        required: true,
                        message: '总领取数量错误',
                        regulation: 'egt_str',
                        rulesData: 0
                    }
                },
                max_hold_count: {
                    placeholder: '请输入可持有数量',
                    rules: {
                        required: true,
                        message: '可持有数量错误',
                        regulation: 'egt_str',
                        rulesData: 0
                    }
                },
                use_type: {
                    placeholder: '使用时间',
                    rules: {
                        required: true,
                        message: '使用时间错误',
                        regulation: 'egt_str',
                        rulesData: 0
                    }
                },
                use_days: {
                    placeholder: '有效天数',
                    rules: {
                        required: false,
                        message: '有效天数错误',
                        regulation: 'int',
                        rulesData: 0
                    }
                },
                use_start_time: {
                    placeholder: '开始使用时间',
                    rules: {
                        required: true,
                        message: '开始使用时间错误',
                        regulation: 'egt_str',
                        rulesData: 0
                    }
                },
                use_end_time: {
                    placeholder: '截止使用时间',
                    rules: {
                        required: false,
                        message: '截止使用时间',
                        regulation: 'egt_str',
                        rulesData: 0
                    }
                },
                only_month_card: {
                    placeholder: '月卡用户是否可领',
                    rules: {
                        required: false,
                        message: '月卡用户是否可领错误',
                        regulation: 'special',
                        rulesData: '0|1'
                    }
                },
                only_vip: {
                    placeholder: 'vip是否可领',
                    rules: {
                        required: true,
                        message: 'vip是否可领错误',
                        regulation: 'special',
                        rulesData: '0|1'
                    }
                },
                other_activity_tag: {
                    placeholder: '三方活动标识',
                    rules: {
                        required: false,
                        message: '三方活动标识错误',
                        regulation: 'egt_str',
                        rulesData: 0
                    }
                },
                is_show: {
                    placeholder: '是否显示',
                    rules: {
                        required: true,
                        message: '是否显示错误',
                        regulation: 'special',
                        rulesData: '0|1'
                    }
                },
                only_online_pay: {
                    placeholder: '仅线上支付可用',
                    rules: {
                        required: true,
                        message: '仅线上支付可用错误',
                        regulation: 'special',
                        rulesData: '0|1'
                    }
                },
                is_scan: {
                    placeholder: '扫码发券',
                    rules: {
                        required: true,
                        message: '扫码发券错误',
                        regulation: 'special',
                        rulesData: '0|1'
                    }
                },
                grant_num: {
                    placeholder: '请输入扫码发放数量',
                    rules: {
                        required: true,
                        message: '扫码发放数量错误',
                        regulation: 'egt_str',
                        rulesData: 0
                    }
                }
            },
            inspection_data: {
                coupon_mode_code: '',
                name: '',
                description: '',
                full_price: '',
                sub_price: '',
                // bear_price:'',
                grant_quantity: '',
                max_count: '',
                use_start_time: '',
                use_end_time: '',
                only_online_pay: '0',
                is_show: '0',
                status: '0'
            }
        };
    },
    created() {
        _this = this;
    },
    methods: {
           modeChange(){
      
            console.log(_this.order_mode_code_array,'选择订单模式');
        },
        //获取订单模式
        orderModeList() {
            console.log('订单模式');
            _this.options_order_code = [];
            _this.getMode();
        },
        getMode() {
            _this
                .$post('/order/orderModeLists', _this.mode_options_data)
                .then((res) => {
                    // _this.options_order_code = res.data;
                    for (var i = 0; i < res.data.length; i++) {
                        _this.options_order_code.push({
                            code: res.data[i].order_mode.order_mode_code,
                            name: res.data[i].order_mode.name
                        });
                    }
                    console.log(_this.mode_options_data.page * _this.mode_options_data.limit < res.count, '--');

                    if (_this.mode_options_data.page * _this.mode_options_data.limit < res.count) {
                        _this.mode_options_data.page += 1;
                        _this.getMode();
                    } else {
                        _this.mode_options_data.page = 1;
                    }

                    console.log(_this.options_order_code, '_this.options_order_code');
                })
                .catch((err) => {});
        },
        getCouponTag() {
            _this
                .$post('/coupon/getCouponTag')
                .then((res) => {
                    _this.submit_data.coupon_tag = res.data.coupon_tag;
                })
                .catch((err) => {});
        },
        // 增加时间段方法
        addTimeFun() {
            _this.time_synchronization.push({
                start_time: '',
                end_time: ''
            });
        },

        // 移除时间段方法
        popTime() {
            _this.time_synchronization.pop();
        },

        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.mode_options_data = {
                page: 1,
                limit: 10,
                status: '1'
            };
            _this.submit_data = {
                coupon_mode_code: '',
                name: '',
                description: '',
                full_price: '',
                sub_price: '',
                bear_price: '',
                date_synchronization: '',
                time_synchronization: '',
                receive_synchronization: '',
                order_mode_code_array: '',
                grant_quantity: '',
                quantity: '',
                start_time: '',
                end_time: '',
                can_use_day: '',
                max_count: '',
                max_hold_count: '',
                use_start_time: '',

                use_end_time: '',
                use_type: '0',
                use_days: '0',

                only_month_card: '0',
                only_vip: '0',
                other_activity_tag: '',
                is_show: '0',
                status: '',
                only_online_pay: '0',
                is_scan: '0',
                coupon_tag: '',
                clear_coupon_tag: '',
                grant_num: '',
                is_douyin: '0',
                is_padan: '0',
                is_new_visit: '0'
            };
            _this.inspection_data = {
                name: '',
                description: '',
                full_price: '',
                sub_price: '',
                // bear_price:'',
                grant_quantity: '',
                max_count: '',
                use_start_time: '',
                use_end_time: '',
                only_online_pay: '0',
                is_show: '0',
                status: '0'
            };
            _this.date_switch = false;
            _this.time_switch = false;
            _this.receive_switch = false;
            _this.all_order_isTrue = false;

            _this.time_synchronization = [
                {
                    start_time: '',
                    end_time: ''
                }
            ];

            _this.date_week = [];
            _this.date_month = [];
            _this.date_date = [];
            _this.receive_year = '';
            _this.receive_month = '';
            _this.receive_week = '';
            _this.receive_day = '';
            _this.order_mode_code_array = [];
        },

        toJSON() {
            // 判断使用时间，如果为0 则有效天数给后台传0，如果是1，则使用开始日期和使用结束日期给后台传空
            if (_this.submit_data.use_type == '0') {
                _this.submit_data.use_days = '0';
                _this.submit_rules.use_start_time.rules.required = true;
                _this.submit_rules.use_end_time.rules.required = true;
                _this.submit_rules.use_days.rules.required = false;
            } else {
                _this.submit_data.use_start_time = '';
                _this.submit_data.use_end_time = '';
                _this.submit_rules.use_start_time.rules.required = false;
                _this.submit_rules.use_end_time.rules.required = false;
                _this.submit_rules.use_days.rules.required = true;
            }
            // 判断可用日期开关状态
            if (_this.date_switch) {
                _this.submit_data.date_synchronization = JSON.stringify({
                    month: _this.date_month,
                    day: _this.date_date,
                    week: _this.date_week
                });
            } else {
                _this.submit_data.date_synchronization = JSON.stringify({
                    all: '1'
                });
            }

            // 判断可用时间段开关状态
            if (_this.time_switch) {
                _this.submit_data.time_synchronization = JSON.stringify(_this.time_synchronization);
            } else {
                _this.submit_data.time_synchronization = JSON.stringify({
                    all: '1'
                });
            }

            // 判断领取限制开关状态
            if (_this.receive_switch) {
                _this.submit_data.receive_synchronization = JSON.stringify({
                    month: _this.receive_month,
                    year: _this.receive_year,
                    day: _this.receive_day,
                    week: _this.receive_week
                });
            } else {
                _this.submit_data.receive_synchronization = JSON.stringify({
                    all: '1'
                });
            }

            // 判断模式开关
            if (_this.all_order_isTrue) {
                _this.submit_data.order_mode_code_array = JSON.stringify(_this.order_mode_code_array);
            } else {
                _this.submit_data.order_mode_code_array = '';
                // _this.submit_data.order_mode_code_array = [];
                // _this.submit_data.order_mode_code_array = JSON.stringify([]);

            }

            if (_this.submit_data.coupon_tag == '') {
                // _this.submit_data.clear_coupon_tag = '0';
                _this.submit_data.clear_coupon_tag = '1';
            }
        },
        // 提交
        onSubmitDig() {
            // 触发父组件自定义事件刷新表格
            _this.$emit('onSubmit');
            _this.closeDialog();
        }
    }
};
</script>

<style scoped>
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}

.avatar-uploader {
    width: 100px;
    height: 100px;
}
</style>
